import { State } from "../../client";

interface Props {
  state: State<string>;
  disabled?: boolean;
  placeholder?: string;
}

export function SecretInput({
  state: [value, setValue],
  disabled,
  placeholder,
}: Props) {
  return (
    <input
      type="password"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder={placeholder ?? "Enter your answer..."}
      disabled={disabled}
    />
  );
}
